import {
  computed, defineAsyncComponent, nextTick, onMounted, reactive, ref, toRefs, onBeforeUnmount
} from 'vue';
import colors from '../colors/colors.vue.component';
import colorThumbnailsList from '../color-thumbnails/color-thumbnails-list.vue.component.js';
import colorSlider from '../colors/color-beauty-slider.vue.component';
import EventBus from '../../scripts/lib/EventBus.js';
import bilderAnsicht from '../bilder-ansicht/bilder-ansicht.vue.component';
import badge from '../badge/badge-liste.vue.component';
import {trackCubePageViewPds, trackProductView, trackSizeSelected} from '../tracking/trackingLayer.js';
import wishlistContainer from '../wishlist-container/wishlist-container.vue.component';
import warenkorbbutton from '../warenkorbbutton/warenkorbbutton.vue.component';
import preisbereich from '../preisbereich/preisbereich.vue.component';
import additionalPriceInfo from '../preisbereich/additional-price-info.vue.component';
import hvaLink from '../hva-link/hva-link.vue.component';
import colorText from '../colors/color-text.vue.component';
import certificate from '../certificate/certificate.vue.component';
import certifiedColumns from '../certified-columns/certified-columns.vue.component';
import { trackABTests } from '../tracking/trackingABTest.js';
import bdkVersion from '@breuni-ui/bdk/dist/version/version.json';

const i18n = JSON.parse(document.querySelector('#vue-data-i18n').textContent);

export default (
  {
    syan,
    article,
    initialKey,
    productJSON,
    productDetailsJSON,
    eventTrackingJSON,
    metaLanguageJSON,
    alwaysDisplayCombiModule,
    appRoot,
    mandatedHost,
    cdnHost,
    wishlistApiTimeout,
    fitaRecoCall,
    showChristmasBear
  }) => ({
  components: {
    'add-to-cart-button': warenkorbbutton,
    'additional-price-info': additionalPriceInfo,
    'bilder-ansicht-thumbnails': defineAsyncComponent(() => import('../bilder-ansicht-thumbnails/bilder-ansicht-thumbnails.vue.component')),
    'certified-columns': certifiedColumns,
    'color-beauty-slider': colorSlider,
    'color-list': colors,
    'color-text': colorText,
    'color-thumbnail-list': colorThumbnailsList,
    'ents-preisbereich': preisbereich,
    'groessen-layer': defineAsyncComponent(() => import('../groessen-layer/groessen-layer.vue.component')),
    'image-main-bildansicht': bilderAnsicht,
    'outfit': defineAsyncComponent(() => import('../outfit/outfit.vue.component')),
    'product-detail-accordion': defineAsyncComponent(() => import('../product-detail-accordion/product-detail-accordion.vue.component')),
    'badge-liste': badge,
    'partnerinfobox': defineAsyncComponent(() => import('../partnerinfobox/partnerinfobox.vue.component')),
    certificate,
    hvaLink,
    wishlistContainer,
  },

  setup() {
    const state = reactive({
      produktId: syan,
      active: article[initialKey],
      activeImage: {},
      artikelNr: initialKey,
      initialNr: initialKey,
      verkaufId: article[initialKey]?.verkaufId, // Use optional chaining for safety
      lastSelectedSize: null,
      artikelListe: article,
      i18n,
      limitiertSaveValue: false,
      exklusivSaveValue: false,
      isMixAndMatchSaveValue: false,
      isKitSaveValue: false,
      trackingStaticData: eventTrackingJSON,
      previewArticle: null,
      previewImage: null,
      previewIsDisplayed: false,
      metaLanguageData: metaLanguageJSON,
      productName: productJSON.name,
      brandName: productJSON.markenname,
      mandatedHost,
      showChristmasBear
    });

    const bdkCdnUri = `${cdnHost}bdk/v${bdkVersion.version}/`;
    const isNew = ref(null);
    const isBuegelleicht = ref(null);
    const wishlistItems = ref([]);

    const productDetails = computed(() => {
      if (productDetailsJSON === '') {
        return {};
      }
      const blueprint = productDetailsJSON.blueprint;
      const artikelContent = productDetailsJSON[state.previewArticle?.colors?.aktiv?.farbId || state.artikelNr];

      return {
        ...blueprint,
        ...artikelContent,
      };
    });

    const displayPrice = computed(() => {
      if (state.previewArticle && state.previewArticle.preis) {
        return state.previewArticle.preis;
      }
      return state.active.preis;
    });

    const farbeChange = (colorId) => {
      const artikelNr = getArticleIdForColor(colorId);

      selectArtikelById(artikelNr, false);
      triggerVariantenwechselEvents();
      handleCombiModuleDisplay(!(state.active.outfits && state.active.outfits.length > 0));
      changeMetaLanguageHeader();
    };

    const getArticleIdForColor = (colorId) => {
      const jsonArtikel = productJSON.artikel[colorId];

      let articleNumber = colorId;

      // keep the selected size, when change colors
      if (jsonArtikelHasColors(jsonArtikel) && jsonArtikelHasGroessen(jsonArtikel)) {
        jsonArtikel.groessen.werte.forEach((item) => {
          if (item.name === state.lastSelectedSize && item.artikelNr !== undefined) {
            articleNumber = item.artikelNr;
          }
        });
      }

      return articleNumber;
    };

    function getArticleForColor(colorId) {
      return productJSON.artikel[getArticleIdForColor(colorId)];
    }

    const handleCombiModuleDisplay = (displayCombiModule) => {
      const shouldShowCombiModule = displayCombiModule || alwaysDisplayCombiModule;
      const combiModuleContainer = document.querySelector('.ents-combi-module-container');
      const combiModule = document.querySelector('.ents-combi-module-container > reco-kombi-modul-loader');
      if (shouldShowCombiModule && state.active.colors !== undefined) {
        combiModule?.setAttribute('color-id', state.active.colors.aktiv.farbId);
        combiModuleContainer.classList.remove('ents-combi-module-container-hide');
      } else {
        combiModuleContainer.classList.add('ents-combi-module-container-hide');
      }
    };

    const triggerVariantenwechsel2Gwpbanner = () => {
      const gwpbanner = document.querySelector('camp-gwpbanner');
      if (gwpbanner) {

        if (state.active.colors !== undefined) {
          gwpbanner.setAttribute('farb-id', state.active.colors.aktiv.farbId);
        } else {
          gwpbanner.removeAttribute('farb-id');
        }

        if (state.verkaufId === undefined || state.verkaufId === null) {
          gwpbanner.removeAttribute('artikel-id');
        } else {
          gwpbanner.setAttribute('artikel-id', state.verkaufId);
        }
      }
    };

    const farbePreview = (artikelNr) => {
      if (artikelNr === undefined || artikelNr === null) {
        state.previewIsDisplayed = false;
        // delay slightly to not drop preview due to javascript event speed hovering between pictures
        window.setTimeout(() => {
          if (!state.previewIsDisplayed) {
            state.previewArticle = null;
            state.previewImage = null;
            fireFinalpriceEvent(!displayPrice.value.isFromPrice, artikelNr);
          }
        }, 50);
      } else {
        state.previewIsDisplayed = true;
        state.previewImage = article[artikelNr].ansichten[0];
        state.previewArticle = article[artikelNr];
        fireFinalpriceEvent(!displayPrice.value.isFromPrice, artikelNr);
      }
    };

    function fireFinalpriceEvent(includeInitialSalesInformationId, artikelNr) {
      const finalPriceUpdatePayload = getActiveArticleIdChainWithoutEntsDummyValues(includeInitialSalesInformationId, artikelNr);
      document.dispatchEvent(new CustomEvent('kaufen:finalpreis:update', {
        detail: finalPriceUpdatePayload,
      }));
      appRoot.setAttribute('data-test-bewerten-last-emitted-finalpreis-payload', JSON.stringify(finalPriceUpdatePayload));
    }

    function dimensionChange(selectParams) {
      if (selectParams.dimension === 'groessen') {
        EventBus.emit('bewerten:vue:sizes:highlight:show', selectParams.add2CartAfterSizeSelection);
      } else {
        const $layer = document.querySelector('#ents-layer__colors');
        if ($layer != null) {
          $layer.classList.remove('hidden');
          $layer.show();
        }
      }
    }

    function layerHide() {
      const $layer = document.querySelector('#ents-layer__colors');
      if ($layer != null) {
        $layer.hide();
      }
    }

    function setNewActiveArtikel(artikelNr) {
      state.active = article[artikelNr];
    }

    const artikelChange = (artikelNr) => {
      selectArtikelById(artikelNr || state.artikelNr, false);
      triggerVariantenwechselEvents();
      state.lastSelectedSize = state.active.groessen.aktiv.name;
      handleCombiModuleDisplay(outfitsMissingInState());
      changeMetaLanguageHeader();
    };

    function changeMetaLanguageHeader() {
      if(state.artikelNr in state.metaLanguageData){
        for(const metaTag of state.metaLanguageData[state.artikelNr]) {
          document.querySelector(`meta[name="${metaTag.name}"]`)?.remove();
          const metaTagElement = document.createElement("meta");
          metaTagElement.setAttribute("name", metaTag.name);
          metaTagElement.setAttribute("content", metaTag.content);
          document.head.append(metaTagElement);
        }
      }
    }

    function jsonArtikelHasColors(jsonArtikel) {
      return jsonArtikel !== undefined && jsonArtikel.colors;
    }

    function jsonArtikelHasGroessen(jsonArtikel) {
      return jsonArtikel !== undefined && jsonArtikel.groessen && jsonArtikel.groessen.werte.length > 1;
    }

    function selectArtikelById(artikelNr, init) {
      const oldImages = state.active.ansichten;
      const newImages = article[artikelNr].ansichten;

      if (compareImageArrays(oldImages, newImages)) {
        // only update images if they differ between current and new article
        const images = state.active.ansichten;
        setNewActiveArtikel(artikelNr);
        state.active.ansichten = images;
      } else {
        setNewActiveArtikel(artikelNr);
      }

      if (hasAliasArticle.value) {
        selectAliasArticle();
      } else {
        state.artikelNr = artikelNr;
        state.verkaufId = state.active.verkaufId;
      }

      if (isInitialArticle.value) {
        selectInitialArticle();
      }

      rewriteURI(init);
      updateProductFamilyUri();
    }

    function compareImageArrays(oldImages, newImages) {
      return oldImages.every((v, i) => v.standardUrl === newImages[i].standardUrl);
    }

    const hasAliasArticle = computed(
      () => state.active.alias !== undefined || false,
    );

    function selectAliasArticle() {
      state.artikelNr = state.active.alias;
      state.verkaufId = state.active.verkaufId;
    }

    const isInitialArticle = computed(
      () => state.active.initial || false,
    );

    function selectInitialArticle() {
      if (state.active[mandatoryDimension.value] && state.active[mandatoryDimension.value].werte.length === 1) {
        selectArtikelById(state.active[mandatoryDimension.value].werte[0].artikelNr, true);
      }
    }

    const mandatoryDimension = computed(() => {
      // FIXME: introduce flag in json data?
      let dimension = null;
      if (state.active.groessen) {
        dimension = 'groessen';
      } else {
        dimension = 'colors';
      }
      return dimension;
    });

    function rewriteURI(init) {
      const location = window.location;
      const pathname = location.pathname;
      const queryString = location.search;

      if (window.history.replaceState) {
        let uri;
        if (init) {
          uri = pathname + queryString.replace(/(variant=)[^&]+/, `$1${state.artikelNr}`);
        } else {
          uri = `${pathname}?variant=${state.artikelNr}`;
        }
        window.history.replaceState(null, null, uri);
      }
    }

    function updateProductFamilyUri() {
      EventBus.emit('ents:vue:product-family:update', state.active.productFamilyUri);
    }

    function triggerVariantenwechselEvents() {
      sendProductViewTracking();
      triggerExternesVariantenwechselEvent();
      triggerVariantenwechsel2Gwpbanner();
    }

    function sendProductViewTracking() {
      const idChain = getActiveArticleIdChainWithoutEntsDummyValues();
      const lieferprognose = eventTrackingJSON.lieferprognose[idChain.artikelId];

      const productViewDetails = {
        event_data: {
          is_interaction_event: false,
          viewed_item_flags: [],
          ressort: eventTrackingJSON.worldAssignment ?? '',
        },
        currency: {
          code: eventTrackingJSON.waehrung,
        },
        items: [{
          syan: idChain.syan,
          farb_id: idChain.farbId,
          artikel_id: idChain.artikelId,
          vertriebsinfo_id: idChain.vertriebsinfoId,
          delivery_status_min_days: lieferprognose ? lieferprognose.versandMinimumTage : null,
          delivery_status_max_days: lieferprognose ? lieferprognose.versandMaximumTage : null,
          is_available: !state.active.outOfStock,
        }],
      };

      // There are a max of 3 flags visible at once on the PDS. Tracking should only contain visible tags.
      // That´s why we need to make sure, the flag conditions are in the same order as they are on the badge-liste.peb
      // to make sure the right ones are getting added to the tracking.
      const flagsConditions = [
        {
          condition: () => state.active.preis.saleFlagContent,
          flag: 'sale'
        },
        {
          condition: () => state.active.exklusiv,
          flag: 'exklusiv'
        },
        {
          condition: () => state.active.limitiert,
          flag: 'limitiert'
        },
        {
          condition: () => isNew.value && !state.active.preis.saleFlagContent,
          flag: 'neu'
        },
        {
          condition: () => productDetails.value.certifiedColumns && productDetails.value.certifiedColumns.length > 0,
          flag: 'zertifiziert'
        },
        {
          condition: () => state.active.isMixAndMatch || state.active.isKit,
          flag: 'mix & match'
        },
        {
          condition: () => isBuegelleicht.value,
          flag: 'buegelleicht'
        },
      ];

      flagsConditions.some(({
                              condition,
                              flag
                            }) => {
        if (productViewDetails.event_data.viewed_item_flags.length >= 3) {
          return true; // Stop the iteration if 3 flags have been added
        }

        if (condition()) {
          productViewDetails.event_data.viewed_item_flags.push(flag);
        }

        return false;
      });

      trackProductView(productViewDetails);
    }

    function triggerExternesVariantenwechselEvent() {
      const payload = getActiveArticleIdChainWithoutEntsDummyValues();
      appRoot
        .setAttribute('data-test-bewerten-last-emitted-variantenwechsel-payload', JSON.stringify(payload));
      document.dispatchEvent(new CustomEvent('bewe:ents:variantenwechsel', {
        detail: payload,
      })); // shared event used by other teams (e.g. BRTN, CAMP, KAUF)

      const finalPriceUpdatePayload = getActiveArticleIdChainWithoutEntsDummyValues(!displayPrice.value.isFromPrice);
      document.dispatchEvent(new CustomEvent('kaufen:finalpreis:update', {
        detail: finalPriceUpdatePayload,
      }));
      appRoot.setAttribute('data-test-bewerten-last-emitted-finalpreis-payload', JSON.stringify(finalPriceUpdatePayload));
    }

    function getActiveArticleIdChainWithoutEntsDummyValues(includeInitialSalesInformationId, articleId = undefined) {
      const jsonArtikel = articleId ? article[articleId] : state.active;
      const produktId = state.produktId;
      if (jsonArtikel) {
        const idChain = {
          syan: produktId,
          // artikelId: optional,
          // farbId: optional
        };
        if (jsonArtikel.colors) {
          idChain.farbId = jsonArtikel.colors.aktiv.farbId;
        }

        if ((includeInitialSalesInformationId || !jsonArtikel.initial) && jsonArtikel.vertriebsinfoId) {
          idChain.vertriebsinfoId = jsonArtikel.vertriebsinfoId;
        }

        if (!jsonArtikel.initial) {
          idChain.artikelId = jsonArtikel.verkaufId;
        }
        return idChain;
      }
      return null;
    }

    function sendPageviewTracking() {
      trackCubePageViewPds();
    }

    async function fetchWishlistItems() {
      try {
        if (window.location.href.includes('.ents.breuni.de')) {
          // Skip when request doesn't come from the frontend proxy
          return;
        }

        let requestItems;
        if (state.active.colors && state.active.colors.werte.length > 0) {
          requestItems = state.active.colors.werte.map(color => ({syan, colorId: color.farbId}));
        } else {
          requestItems = [{syan, colorId: null}];
        }

        const response = await fetch(`${mandatedHost}ents/api/v1/wishlist/contains`, {
          signal: AbortSignal.timeout(wishlistApiTimeout),
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(requestItems),
          credentials: 'include'
        });

        const responseData = await response.json();
        wishlistItems.value = responseData.map(i => `${i.syan.toString()}${i.colorId ? '-' : ''}${i.colorId ?? ''}`);
      } catch (e) { // eslint-disable-line @typescript-eslint/no-unused-vars
        // timeout or invalid data / response json
      }
    }

    const syanColorsOnWishlist = computed(() => {
      return JSON.stringify(wishlistItems.value);
    });

    EventBus.on('bewerten:vue:flags:update', (flags) => {
      isBuegelleicht.value = flags.isBuegelleicht;
      isNew.value = flags.isNew;
    });

    EventBus.on('bewerten:out-of-stock-layer:show', (vertriebsinfoId) => {
      document.dispatchEvent(new CustomEvent('pruefen:best:wvb-overlay:open', {
        detail: {
          vertriebsinfoId,
          source: 'pds',
        },
      }));
    });

    onMounted(() => {
      EventBus.on('bewerten:vue:color:changed', farbeChange);
      EventBus.on('bewerten:vue:farbe:preview', farbePreview);
      EventBus.on('bewerten:vue:artikel:changed', artikelChange);
      EventBus.on('bewerten:vue:dimension:select', dimensionChange);
      EventBus.on('bewerten:vue:layer:hide', layerHide);
      EventBus.on('ents:vue:product-family:created', () => {
        updateProductFamilyUri();
      });
      EventBus.on('ents:vue:display-combi-module', () => {
        handleCombiModuleDisplay(true);
      });

      nextTick(() => {
        if (isInitialArticle.value) {
          // select single available article for dimensions with only one article
          selectInitialArticle();
        } else {
          // update variant in URL if needed
          rewriteURI(true);
        }

        if (hasAliasArticle.value) {
          selectAliasArticle();
        }

        sendProductViewTracking();

        const body = document.getElementsByTagName('body')[0];
        body.classList.add('bewerten-body--ready');
        document.dispatchEvent(new CustomEvent('bewe:ents:vue-ready'));
      });

      updateProductFamilyUri();
      changeMetaLanguageHeader();
      window.performance.mark('bewe.pds.vue.mounted');
      window.performance.measure('bewe.pds.vue.ready', 'domInteractive', 'bewe.pds.vue.mounted');
      sendPageviewTracking();
      document.dispatchEvent(new CustomEvent('camp:aktionsflags:initialized'));
      handleCombiModuleDisplay(outfitsMissingInState());
      window.addEventListener('keydown', boundStopFarbePreview);

      window.addEventListener('pageshow', onPageShow);
      fetchWishlistItems();
      if (fitaRecoCall) {
        fetchFitaReco();
      }
    });

    async function fetchFitaReco() {
      fetch(`${mandatedHost}brtn/api/fitanalytics/recommendation?syan=${state.produktId}&colorId=${state.active?.colors?.aktiv.farbId}`,
        { signal: AbortSignal.timeout(1000) }, { method: 'GET' }, { credentials: 'include' })
        .then(res => (res.status === 200 ? res.json() : console.info('Nothing valid from fita reco !')))
        .then((json) => {
          if (json.articleId in state.artikelListe) {
            artikelChange(json.articleId);
            trackSizeSelected(
              state.produktId,
              json.articleId,
              state.active.vertriebsinfoId,
              state.active.colors?.aktiv?.farbId,
              state.active.outofstock,
              'size_recommendation'
            );
          }
        })
        .catch((error) => {
          if (error.name === 'TimeoutError') {
            console.info('FitAnalytics recommendation request timed out');
          }
        });
    }

    const boundStopFarbePreview = stopFarbePreview.bind(this);

    onBeforeUnmount(() => {
      window.removeEventListener('keydown', 'keydown', boundStopFarbePreview);
      window.removeEventListener('pageshow', onPageShow);
    });

    function onPageShow(e) {
      if (e.persisted) {
        fetchWishlistItems();
      }
    }

    function stopFarbePreview(event) {
      if (event.key === 'Escape') {
        EventBus.emit('bewerten:vue:farbe:preview', null);
      }
    }

    function outfitsMissingInState() {
      return !(state.active.outfits && state.active.outfits.length > 0);
    }

    trackABTests();

    return {
      ...toRefs(state),
      article,
      productDetails,
      displayPrice,
      getActiveArticleIdChainWithoutEntsDummyValues,
      mandatoryDimension,
      isInitialArticle,
      isNew,
      getArticleForColor,
      syanColorsOnWishlist,
      bdkCdnUri
    };
  },
});
